import { render, staticRenderFns } from "./NameValueVerticalWithUnit.vue?vue&type=template&id=4a5f6826&scoped=true"
import script from "./NameValueVerticalWithUnit.vue?vue&type=script&lang=js"
export * from "./NameValueVerticalWithUnit.vue?vue&type=script&lang=js"
import style0 from "./NameValueVerticalWithUnit.vue?vue&type=style&index=0&id=4a5f6826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f6826",
  null
  
)

export default component.exports